import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonios } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-ink py-16 sm:py-20" aria-labelledby="testimonios" data-id="element-155" data-mp="3kqw2sg9ckue0">
      <div className="mx-auto max-w-readable px-5 sm:px-8" data-id="element-156" data-mp="3fy2whny8ddzt">
        <p className="font-display text-sm font-bold uppercase tracking-[0.28em] text-leaf" data-id="element-157" data-mp="3b1ckpctgl4k7">
          ❤️ Lo que dicen quienes ya lo tienen
        </p>
        <h2 id="testimonios" className="mt-4 font-display text-3xl font-extrabold text-cream sm:text-4xl" data-id="element-158" data-mp="36wwefafxnv4g">
          Resultados reales, en semanas reales
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-159" data-mp="2x2w2aom8hpm8">
          {testimonios.map(t => <figure key={t.author} className="flex h-full flex-col rounded-2xl border border-ink-600 bg-ink-800 p-6" data-id="element-160" data-mp="2s3jjqg2eb4pg">
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-161" data-mp="qbetd90jofgu">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-162" data-mp="h4n6uketiff5" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-[16px] leading-relaxed text-cream/85" data-id="element-163" data-mp="7a4xozqmtrny">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto flex flex-wrap items-center gap-x-2 gap-y-1 pt-5 text-[13px] text-cream/55" data-id="element-164" data-mp="zw64ebq2p19s">
                <span className="font-semibold text-cream/80" data-id="element-165" data-mp="14u7ql5ispgph">{t.author}</span>
                <span aria-hidden="true" data-id="element-166" data-mp="q7ehihzvd75q">·</span>
                <span data-id="element-167" data-mp="q4jxusoojqdd">{t.city}</span>
                <span className="rounded-full border border-ink-600 px-2 py-0.5 text-[11px] uppercase tracking-wide" data-id="element-168" data-mp="v57ld4dp9p2u">
                  {t.plan}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}